export default {"src":"/_next/static/media/successFeedbackMessage.9bb2556e.svg","height":105,"width":105};